import * as THREE from 'three';
import TWEEN from '@tweenjs/tween.js';
import {USE_LEGACY_TWEEN_GROUP} from 'components/customer/Preview3DCommon/lib/tween';
import {TemplateVariable} from 'components/customer/Preview3D/usePreview3DData';
import {AnimationHandler} from 'components/customer/Preview3D/animation/entity/AnimationHandler';

export const toggleDoorHandler = ({
    mesh,
    variables,
    isRightDoor = false,
    isTopHangDoor = false,
    degrees = 120,
    animationDelay = 0,
}: {
    mesh: THREE.Group<THREE.Object3DEventMap> | THREE.Mesh;
    variables: TemplateVariable;
    isRightDoor?: boolean;
    isTopHangDoor?: boolean;
    degrees?: number;
    isThreeDoor?: boolean;
    animationDelay?: number;
}): AnimationHandler => {
    const radians = (degrees * Math.PI) / 180;
    const hasInnerDrawer = variables?.innerDrawerCount > 0;

    const initialRotation = isTopHangDoor ? {x: (90 * Math.PI) / 180} : {y: 0};
    const openRotation = isTopHangDoor
        ? {x: -(17 * Math.PI) / 180}
        : {y: isRightDoor ? radians : -radians};
    const closeRotation = isTopHangDoor ? {x: (90 * Math.PI) / 180} : {y: 0};

    const openDoor = (animationSpeed = 1000) =>
        new Promise<void>((resolve) => {
            const delay = animationSpeed !== 0 ? animationDelay : 0;
            const openTween = new TWEEN.Tween(
                initialRotation,
                USE_LEGACY_TWEEN_GROUP
            )
                .to(openRotation, animationSpeed)
                .easing(TWEEN.Easing.Quadratic.Out)
                .delay(
                    variables?.is3DoorProduct && animationSpeed !== 0
                        ? 300
                        : delay
                )
                .onComplete(() => {
                    resolve();
                })
                .onUpdate(() => {
                    if (isTopHangDoor) mesh.rotation.x = initialRotation.x;
                    else mesh.rotation.y = initialRotation.y;
                });
            openTween.start();
        });
    const closeTween = (animationSpeed = 1000) =>
        new Promise<void>((resolve) => {
            const closeTween = new TWEEN.Tween(
                initialRotation,
                USE_LEGACY_TWEEN_GROUP
            )
                .to(closeRotation, animationSpeed)
                .easing(TWEEN.Easing.Quadratic.Out)
                .delay(
                    (variables?.is3DoorProduct || hasInnerDrawer) &&
                        animationDelay === 0
                        ? 300
                        : animationDelay
                )
                .onComplete(() => {
                    resolve();
                })
                .onUpdate(() => {
                    if (isTopHangDoor) mesh.rotation.x = initialRotation.x;
                    else mesh.rotation.y = initialRotation.y;
                });

            closeTween.start();
        });

    return {
        open: [openDoor],
        close: [closeTween],
    };
};
